export const throttle = (callback: () => void, delay: number) => {
  let throttlePause = false

  return () => {
    if (throttlePause) {
      return
    }

    throttlePause = true

    setTimeout(() => {
      callback()
      throttlePause = false
    }, delay)
  }
}
